<p-button
  *ngIf="variant === 'menuItem'"
  class="menu-item lang-switcher-menu-item"
  [label]="label"
  variant="text"
  severity="secondary"
  icon="pi pi-globe"
  size="small"
  (click)="toggle()">
</p-button>

<button
  *ngIf="variant === 'standalone'"
  type="button"
  class="lang-switcher-standalone"
  (click)="toggle()">
  <i class="pi pi-globe"></i>
  <span>{{ label }}</span>
</button>
